import React from 'react';

import { useActiveUser } from 'shared/store/modules/user/hooks';
import { useActiveCustomer } from 'shared/store/modules/customers/hooks';

import { Content } from './Content';
import { Header } from './Header';
import { Navigation } from './Navigation';
import { Router } from './Router';
import { SessionTimer } from './SessionTimer';
import { Theme } from './Theme';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import styles from './ApplicationLayout.styles';
import { useDispatch, useSelector } from 'react-redux';

import { toggleNav } from 'shared/store/modules/nav/actions';
import { getIsNavOpen } from 'shared/store/modules/nav/selectors';
import { RootState } from 'shared/store/types';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { selectActiveAccount } from 'shared/store/modules/accounts/selectors';
import { useLocation } from 'react-router-dom';

export const DisplaySystemMessage = ({
  systemMaintenanceMessage,
  mobile = false
}: {
  systemMaintenanceMessage: string | null;
  mobile?: boolean;
}) => {
  if (!systemMaintenanceMessage) {
    return null;
  }
  return (
    <div className={`system-message ${mobile ? 'mobile' : ''}`}>
      <FontAwesomeIcon icon={faInfoCircle} className="mr-2 icon" />
      <div>{systemMaintenanceMessage}</div>
    </div>
  );
};

export function ApplicationLayout() {
  useActiveUser();
  useActiveCustomer();
  const dispatch = useDispatch();
  const location = useLocation();

  const isCheckout = location.pathname.includes('checkout') || location.pathname.includes('confirmation');
  const isNavOpen = useSelector(getIsNavOpen);
  const systemMaintenanceMessage = useSelector((state: RootState) => state.systemMaintenanceMessage as string | null);
  const account = useSelector(selectActiveAccount);

  const multipleAccountNames = account.customerName !== account.name && Boolean(systemMaintenanceMessage);

  return (
    <Theme>
      <div css={styles}>
        {!isCheckout && <DisplaySystemMessage systemMaintenanceMessage={systemMaintenanceMessage} />}
        <div className="wrapper">
          {!isCheckout && <Header />}

          <div
            className={`layout ${multipleAccountNames ? 'extra-padding-mobile' : ''}`}
            onClick={() => (isNavOpen ? dispatch(toggleNav()) : {})}
          >
            {!isCheckout && <Navigation />}

            <Content>
              <Router />
            </Content>
          </div>

          <SessionTimer />
        </div>
      </div>
    </Theme>
  );
}
